import type { ActionsWrapperProps } from './ActionsWrapper.types'
import cn from 'classnames'
import * as React from 'react'
import styles from './ActionsWrapper.module.css'

export function ActionsWrapper({ children, actionsPosition, className }: ActionsWrapperProps) {
  return (
    <div
      className={cn(
        styles.actionsWrapper,
        { [styles.actionsWrapperBottom]: actionsPosition === 'bottom' },
        className,
      )}
    >
      {children}
    </div>
  )
}
